import { USER_ACTION_TYPES, USER_ACTIONS } from "../actions/user"
import { apiStatusStateType, apiStatusInitialState } from "../misc"
import { ClusterApi } from "@cluster/web-components";
import produce, { enableES5} from "immer"
import { AuthTokenData } from "../../lib/app-api"

enableES5();

export interface UserStateType extends ClusterApi.AuthResponse {
  loggedIn: boolean,
  favoriteCells: number[],
  authStatus: apiStatusStateType,
  authSourceToken?: AuthTokenData,
  tokenRefreshLocked: boolean
}

export const initialState: UserStateType = {
  user: {
    id: 0,
    email: "",
    firstName: "",
    lastName: "",
  },
  token: "",
  msgCredentials: {
    username: "",
    password: ""
  },
  loggedIn: false,
  favoriteCells: [],
  authStatus: apiStatusInitialState,
  tokenRefreshLocked: false
}

export default (state = initialState, action: USER_ACTION_TYPES): UserStateType => {

  switch (action.type) {
    case USER_ACTIONS.AUTH_USER_START:
      return {
        ...state,
        authStatus: {
          ...state.authStatus,
          loading: true,
          errorCode: null,
          developerMessage: null,
          userMessage: null,
          moreInfo: null,
        }
      }
    case USER_ACTIONS.AUTH_USER_SUCCESS:
      if (action.payload) {
        return {
          ...state,
          ...action.payload,
          loggedIn: true,
          authStatus: {
            ...state.authStatus,
            lastFetch: Date.now(),
            errorCode: null,
            developerMessage: null,
            userMessage: null,
            moreInfo: null,
            lastError: null,
            loading: false
          }
        }
      }
      // caution: break is omitted intentionally if the payload is falsey

    case USER_ACTIONS.AUTH_USER_ERROR:
      return {
        ...state,
        authStatus: {
          ...state.authStatus,
          ...action.error,
          lastError: Date.now(),
          loading: false
        }
      }
    case USER_ACTIONS.REWRITE_TOKEN:
      return {
        ...state,
        token: action.payload??""
      }
    case USER_ACTIONS.AUTH_SOURCE_TOKEN_SET:

      return {
        ...state,
        authSourceToken: action.payload
      }
    case USER_ACTIONS.FAVORITES_SET:
      return {
        ...state,
        favoriteCells: action.payload as number[]
      }
    case USER_ACTIONS.FAVORITE_ADDED:
      return {
        ...state,
        favoriteCells: produce(state.favoriteCells, draft => {
          const cellId = action.payload as number;
          if (!draft.includes(cellId)) {
            draft.push(cellId);
          }
        })
      }
    case USER_ACTIONS.FAVORITE_REMOVED:
      return {
        ...state,
        favoriteCells: produce(state.favoriteCells, draft => {
          const cellId = action.payload as number;
          const cellIndex = draft.indexOf(cellId);

          if (cellIndex !== -1) {
            delete draft[cellIndex];
          }
        })
      }
    case USER_ACTIONS.TOKEN_REFRESH_LOCKED:
      return {
        ...state,
        tokenRefreshLocked: true
      }
    case USER_ACTIONS.TOKEN_REFRESH_UNLOCKED:
      return {
        ...state,
        tokenRefreshLocked: false
      }
    default:
      return state
  }
}